import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = {
  key: 0,
  class: "drv-py-2"
}

import HelpLink from "../HelpLink.vue";
import { computed, ref, watch } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  EAuthTypes,
  IBaseDotNumber,
  ECommonMessages,
  EInsurerMessagesKeys,
  EPlatformName,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import { requiredValidator, regexpValidator } from "draivn-ui-domain";
import { DOT_REGEXP, HELP_URL_BY_PLATFORM } from "../../../../constants";
import { useOnboardingStore } from "@/modules/onboarding";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseDotNumber',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const EMPTY_MODEL = {
  type: EAuthTypes.ACCOUNT,
  dotNumber: null,
};

const insurerUsdot = computed<string>(() => {
  let usdot: string | null =
    useOnboardingStore().model.sections?.insurer?.data?.customer?.usdot;
  return usdot?.length ? usdot : null;
});

const model = computed<IBaseDotNumber>({
  get() {
    const result = props.modelValue ?? EMPTY_MODEL;
    if (result.dotNumber === null) {
      result.dotNumber = insurerUsdot.value != null ? insurerUsdot.value : "";
    }
    return result;
  },
  set(value: IBaseDotNumber) {
    emit("update:modelValue", value);
  },
});

watch(insurerUsdot, (valueNew, valueOld) => {
  if (!dotNumber.value?.length || dotNumber.value == valueOld) {
    dotNumber.value = valueNew;
  }
});

const dotNumber = computed<string>({
  get() {
    return model.value?.dotNumber ?? "";
  },
  set(value: string) {
    model.value = { ...model.value, dotNumber: value };
  },
});

const dotNumberControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return !dotNumber.value || dotNumberControl.value?.hasError;
});

const textByPlatformName: Partial<
  Record<
    EPlatformName,
    { title: string; inputTitle: string; url: string; showBanner: boolean }
  >
> = {
  [EPlatformName.SIMPLE_TRUCK_ELD]: {
    title: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_TITLE,
    inputTitle: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_INPUT_TITLE,
    url: HELP_URL_BY_PLATFORM[props.platform.const],
    showBanner: false,
  },
  [EPlatformName.SIMPLE_E_LOG]: {
    title: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_TITLE,
    inputTitle: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_INPUT_TITLE,
    url: HELP_URL_BY_PLATFORM[props.platform.const],
    showBanner: false,
  },
  [EPlatformName.GLOBAL_ELD]: {
    title: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_TITLE,
    inputTitle: ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_INPUT_TITLE,
    url: HELP_URL_BY_PLATFORM[props.platform.const],
    showBanner: false,
  },
};

const currentText = computed<{
  title: string;
  inputTitle: string;
  url: string;
  showBanner: boolean;
}>(() => {
  return (
    textByPlatformName[props.platform.const] ?? {
      title: ETelematicsMessagesKeys.BASE_DOTNUMBER_INSTRUCTION_TITLE,
      inputTitle: ETelematicsMessagesKeys.BASE_BASIC_TITLE,
      url: HELP_URL_BY_PLATFORM[props.platform.const],
      showBanner: true,
    }
  );
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_snackbar = _resolveComponent("d-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(currentText.value.title)), 1),
      (currentText.value.url)
        ? (_openBlock(), _createBlock(HelpLink, {
            key: 0,
            link: _ctx.$t(currentText.value.url)
          }, null, 8, ["link"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_d_input, {
      ref_key: "dotNumberControl",
      ref: dotNumberControl,
      class: "drv-form-control-adaptive drv-my-2",
      modelValue: dotNumber.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dotNumber).value = $event)),
      disable: _ctx.disable,
      label: _ctx.$t(currentText.value.inputTitle),
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(regexpValidator)(
          _unref(DOT_REGEXP),
          _ctx.$t(_unref(EInsurerMessagesKeys).VALIDATORS_DOT_COMMON_MESSAGE)
        ),
      ]
    }, null, 8, ["modelValue", "disable", "label", "rules"]),
    (currentText.value.showBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_d_snackbar, {
            icon: "triangle-exclamation",
            class: "drv-bg-color-b100 drv-color-b600",
            message: 
          _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_DOTNUMBER_BANNER_INSTRUCTION_TEXT, {
            tspName: _ctx.platform.label,
          })
        
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})